var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdgeAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#fff",
    stroke: "#1D7777"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edge_add_svg__clip0_2719_317)",
    stroke: "#1D7777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.4v11.2M4.4 10h11.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edge_add_svg__clip0_2719_317"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3 3)",
    d: "M0 0h14v14H0z"
  })))));
}
export default SvgEdgeAdd;